import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';

import OrangeRewardsbutton from 'assets/images/OrangeRewardsbutton.png';
import PurpleMessagesbutton from 'assets/images/PurpleMessagesbutton.png';
import SearchInput from 'components/SearchModal/SearchInput';

import BackImage from 'custom/BackImage/BackImage';

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  SweetAlert,
  LanguageSelect,
  GlassWidgetPanel,
} from 'C4';
import { storageKeys, bgVideo } from 'settings';

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      appId: -1,
      unreadMessageCount: 0,
      lastCheckedMessages: '',
      appId: -1,
      userStatus: 'startTraining',
      noAgent: false,
      germanVersion: false,
      popup: false,
      openMessage: false,
      messagePopup: {},
      logo: null,
      landingQuote: null,
      background: null,
      firstName: '',
      lastName: '',
      email: '',
      hasUser: null,
    };

    this.close = this.close.bind(this);
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.training_graduated) {
        return this.setState({ userStatus: 'graduated' });
      }
      if (res.training_started) {
        return this.setState({ userStatus: 'continueTraining' });
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });

      StorageHandler.load(storageKeys.user).then((user) => {
        this.setState({ hasUser: Boolean(user && user.email) });

        if (user) {
          this.setState({
            firstName: user.first_name,
            lastName: user.last_name,
            email: user.email,
          });
        }
        if (user && user.sales_companion_registered === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;

          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        }
      });
    });

    this.getAppInfo();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logo,
        background: appInfo.splash_screen,
      });
    }
  }

  close() {
    this.setState({
      popup: false,
    });
  }

  openPopup() {
    this.setState({
      openMessage: true,
    });
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages,
    ).then((res) => {
      this.setState({ unreadMessageCount: res.missed_items[0].count });
    });
  }

  render() {
    const {
      userStatus,
      popup,
      logo,
      landingQuote,
      messagePopup,
      openMessage,
      appId,
      background,
      firstName,
      lastName,
      email,
      hasUser,
    } = this.state;

    const open = () => {
      this.setState({
        popup: true,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}
        <BackImage src={background} />
        <img
          src="https://front.travpromobile.com/1795/gradientbottom.png"
          className="gradientBottom"
          alt="logo"
        />
        <div className="bgHome" />
        <div className="buttonWrapper">
          Download now:
          <StoreButtons />
        </div>
        <LanguageSelect />
        <div className="swoop" />
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <img
                  src="https://front.travpromobile.com/1795/1773333775-lauderdalelocalcolorwhitestackedlogo.png"
                  className="homeLogo"
                  alt="logo"
                />

                <h1 className="homeView__text">Lauderdale Local</h1>
                <div className="homeView__title--action">
                  <SearchInput />

                  <div className="homepage__buttons">
                    {/* <Link to="/main/messages" className="messageBtn">
                      <img
                        className="PurpleMessagesbutton"
                        src={PurpleMessagesbutton}
                      />
                      <div>
                        <p>
                          <FontAwesomeIcon icon={["fas", "envelope"]} />
                          {i18n.translate("nav.messages")}
                        </p>
                      </div>
                    </Link> */}
                    {/* <Link
                      to="/main/rewards"
                      // TODO: add link to "rewards"
                      className="rewardsBtn"
                      >
                      <img
                        className="OrangeRewardsbutton"
                        src={OrangeRewardsbutton}
                      />
                      <div>
                        <p>
                          <FontAwesomeIcon icon={['fas', 'trophy-star']} />
                          {i18n.translate('nav.achievements')}
                        </p>
                      </div>
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Spring>
        {/* <div className="top-bar" />
        <div className="bottom-bar" />
        <div className="bottom-bg" /> */}
        <div className="bottomLine" />
        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate("close")}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
        <SweetAlert
          title=""
          trigger={popup}
          {...{
            title: '',
            html: 'monaco Rewards are available once you receive your diploma as a certified Lauderdale Local. Please complete the Learning chapters and come back to submit your bookings.',
            confirmButtonText: i18n.translate('general.close'),
            onClose: this.close,
          }}
        />

        <GlassWidgetPanel
          appId={appId}
          position="left"
          firstName={firstName}
          lastName={lastName}
          email={email}
          hasUser={hasUser}
        />
        {/* <NotificationSlider appId={appId} middle right /> */}
        {/* {messagePopup.message && (
          <SweetAlert
            title={messagePopup.message}
            html={messagePopup.messagePopUp}
            trigger={openMessage}
            showConfirmButton={false}
            cancelButtonText={i18n.translate("general.close")}
            showCancelButton
            customClass="homePopup"
          />
        )} */}
      </div>
    );
  }
}
